import { assertNever } from '../assert-never';

export type BinaryOp = '+' | '-' | '*' | '/' | '%' | '^';

export type Node =
  | { readonly kind: 'number'; readonly value: number }
  | { readonly kind: 'identifier'; readonly name: string }
  | { readonly kind: 'variable'; readonly name: string }
  | { readonly kind: 'unary'; readonly op: '+' | '-'; readonly operand: Node }
  | { readonly kind: 'binary'; readonly op: BinaryOp; readonly left: Node; readonly right: Node }
  | { readonly kind: 'call'; readonly name: string; readonly args: readonly Node[] };

export class ExpressionError extends Error {
  constructor(
    message: string,
    readonly position = 0,
  ) {
    super(message);
    this.name = 'ExpressionError';
  }
}

export function dependencies(node: Node, into = new Set<string>()): Set<string> {
  switch (node.kind) {
    case 'number':
      break;
    case 'identifier':
      break;
    case 'variable':
      into.add(node.name);
      break;
    case 'unary':
      dependencies(node.operand, into);
      break;
    case 'binary':
      dependencies(node.left, into);
      dependencies(node.right, into);
      break;
    case 'call':
      for (const arg of node.args) dependencies(arg, into);
      break;
    default:
      assertNever(node);
  }
  return into;
}
